import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VideoConferencePage from './pages/VideoConferencePage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/room/:roomId" element={<VideoConferencePage />} />
        <Route path="/" element={<VideoConferencePage />} />
      </Routes>
    </Router>
  );
}

export default App;
